import { render, staticRenderFns } from "./FrontMiAbono.vue?vue&type=template&id=32b49a54"
import script from "./FrontMiAbono.vue?vue&type=script&lang=js"
export * from "./FrontMiAbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports